<div class="cms-section">
    <ul role="tablist" class="tab">
        <li role="tab" aria-selected="true" aria-controls="panel-1" id="tab-1" class="tablinks" [tabIndex]="1"
            cdkFocusInitial
            [ngClass]="language  === langDe ? 'active' : 'basic'"
            (click)="selectLanguage(langDe)">
            {{ 'GENERAL.GERMAN' | translate }}
        </li>
        <li role="tab" aria-selected="false" aria-controls="panel-2" id="tab-2" class="tablinks" [tabIndex]="1"
            [ngClass]="language === langEn ? 'active' : 'basic'"
            (click)="selectLanguage(langEn)">
            {{ 'GENERAL.ENGLISH' | translate }}
        </li>
        <li role="tab" aria-selected="false" aria-controls="panel-3" id="tab-3" class="tablinks" [tabIndex]="1"
            [ngClass]="language === langSr ? 'active' : 'basic'"
            (click)="selectLanguage(langSr)">
            {{ 'GENERAL.SERBIAN' | translate }}
        </li>
    </ul>

    <form [formGroup]="form" class="cms__editor">
        <div class="row">
            <div class="column">
                <div class="cms__editor__header">
                    <span class="cms__editor__section-title">{{ 'ONBOARDING.LANGUAGE_STYLE.STANDARD_TITLE' | translate }}</span>
                </div>
                <textarea [formControlName]="'titleStandard'" class="cms__editor__edit-title textarea" maxlength="1000"
                          rows="{{titleRows}}">
                </textarea>
                <textarea [formControlName]="'infoStandard'" class="cms__editor__edit-text textarea" maxlength="10000"
                          rows="{{contentRows}}"></textarea>
                <div class="btn-wrapper">
                    <app-button
                            [cssClasses]="'btn full-width rounded-off solid__blue-02'"
                            [icon]="'visibility'"
                            [iconSize]="'16'"
                            [disabled]="!titleStandard.value || !infoStandard.value"
                            [ariaLabel]="'GENERAL.PREVIEW' | translate"
                            (buttonClicked)="onPreviewUnit(titleStandard.value, infoStandard.value, styleStandard)">
                        {{ 'GENERAL.PREVIEW' | translate }}
                    </app-button>
                </div>

            </div>
            <div class="column">
                <div class="cms__editor__header">
                    <span class="cms__editor__section-title">{{ 'ONBOARDING.LANGUAGE_STYLE.SIMPLE_TITLE' | translate }}</span>
                </div>
                <textarea [formControlName]="'titleSimple'" class="cms__editor__edit-title textarea" maxlength="1000"
                          rows="{{titleRows}}">
                </textarea>
                <textarea [formControlName]="'infoSimple'" class="cms__editor__edit-text textarea" maxlength="10000"
                          rows="{{contentRows}}">
                </textarea>
                <div class="btn-wrapper">
                    <app-button
                            [cssClasses]="'btn full-width rounded-off solid__blue-02'"
                            [icon]="'visibility'"
                            [iconSize]="'16'"
                            [disabled]="!titleSimple.value || !infoSimple.value"
                            [ariaLabel]="'GENERAL.PREVIEW' | translate"
                            (buttonClicked)="onPreviewUnit(titleSimple.value, infoSimple.value, styleSimple)">
                        {{ 'GENERAL.PREVIEW' | translate }}
                    </app-button>
                </div>

            </div>
            <div class="column">
                <div class="cms__editor__header">
                    <span class="cms__editor__section-title">{{ 'ONBOARDING.LANGUAGE_STYLE.EASY_TITLE' | translate }}</span>
                </div>
                <textarea [formControlName]="'titleEasy'" class="cms__editor__edit-title textarea" maxlength="1000"
                          rows="{{titleRows}}">
                </textarea>
                <textarea [formControlName]="'infoEasy'" class="cms__editor__edit-text textarea" maxlength="10000"
                          rows="{{contentRows}}">
                </textarea>
                <div class="btn-wrapper">
                    <app-button
                            [cssClasses]="'btn full-width rounded-off solid__blue-02'"
                            [icon]="'visibility'"
                            [iconSize]="'16'"
                            [disabled]="!titleEasy.value || !infoEasy.value"
                            [ariaLabel]="'GENERAL.PREVIEW' | translate"
                            (buttonClicked)="onPreviewUnit(titleEasy.value, infoEasy.value, styleEasy)">
                        {{ 'GENERAL.PREVIEW' | translate }}
                    </app-button>
                </div>

            </div>
        </div>
    </form>

    <div class="cms__footer">
        <div class="btn-wrapper">
            <app-button
                    [cssClasses]="'btn regular outlined__gray-07 outlined full-width'"
                    [ariaLabel]="'GENERAL.CANCEL' | translate"
                    [disabled]="!this.form.dirty"
                    (buttonClicked)="discard()">
                {{ 'GENERAL.DISCARD' | translate }}
            </app-button>
        </div>
        <div class="btn-wrapper">
            <app-button
                    [cssClasses]="'btn regular solid__blue-07 full-width'"
                    [ariaLabel]="'GENERAL.SAVE' | translate"
                    [disabled]="!this.form.dirty"
                    (buttonClicked)="save()">
                {{ 'GENERAL.SAVE' | translate }}
            </app-button>
        </div>
    </div>
</div>

